const customerMarket = {
  personalVehicle: 1,
  truck: 2,
  loaderAndTractor: 3
}

export default customerMarket;